import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('communities', 'removeUserCommunity');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'members',
    {
      type: 'payload',
      selector: ['memberId'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/removeUserCommunity.js